export default {
  computed: {
    configs() {
      const M_PROPINSI = this.masters.propinsi || {};
      const M_KOTA = this.masters.kota || {};
      return {
        selector: ['k_propinsi', 'k_kota'],
        required: [false, false],
        label: ['Provinsi', 'Kabupaten/Kota'],
        options: [M_PROPINSI, M_KOTA],
        grid: [{ cols: 6 }, { cols: 6 }],
        disabled: [this.isPreview, this.isPreview],
      };
    },

    mInstrumen() {
      let result = {};
      const keysMasterInstrumen = {
        fasilitator: ['fsp', 'pmo'],
        sekolah: ['sekolah'],
        daerah: ['daerah'],
        'progres-fsp': ['progres'],
      };

      let keys = keysMasterInstrumen[this.type] || [];
      if (+this.info.pendampingan_tahun >= 2024) {
        keys = Object.keys(this.instrumens).filter((master) => master !== 'ds24-umum');
      }

      for (const key of keys) {
        result[key] = this.instrumens[key];
      }

      return result;
    },

    listInstrumen() {
      let result = {};

      for (const keyInstrumen in this.mInstrumen) {
        const instrumens = this.mInstrumen[keyInstrumen] || [];
        result[keyInstrumen] = [];

        for (const ins of instrumens) {
          const items = (ins.opsi || []).map((opsi) => {
            return {
              text: opsi.keterangan,
              value: opsi.k_koordinator_opsi_psp,
              is_lain: opsi.is_lain,
              validator: opsi.validator,
            };
          });
          const othersValue = items.filter((item) => item.is_lain === 1);
          const otherValue = othersValue[0] || {};

          const validators = (ins.validator || '').split('|');
          let validator = {};
          for (const item of validators) {
            if (item) {
              const val = item.split(':');
              validator[val[0]] = val[1];
            }
          }

          let counter = false;
          if (validator.min_words) {
            counter = true;
          } else if (validator.max_words) {
            counter = validator.max_words;
          } else if (othersValue.length) {
            counter = {};
            for (const val of othersValue) {
              const validators = (val.validator || '').split('|');
              let validator = {};
              for (const item of validators) {
                if (item) {
                  const val = item.split(':');
                  validator[val[0]] = val[1];
                }
              }

              counter[val.value] = validator.min_words || false;
            }
          }

          if (ins.tipe === 'checkbox') {
            result[keyInstrumen].push({
              id: (ins.k_koordinator_instrumen_psp || '').toString(),
              type: 'Checkbox',
              name: `instrumen-checkbox-${ins.k_koordinator_instrumen_psp}`,
              label: ins.keterangan,
              labelColor: 'indigo',
              items,
              hideDetails: true,
              row: true,
              singleLine: true,
              notitle: true,
              class: 'mb-0',
              grid: { cols: 12 },
              itemGrid: { cols: 12, lg: [12, 13].includes(+ins.k_koordinator_instrumen_psp) ? 12 : 4 },
              useOthers: true,
              othersValue: +otherValue.value,
              others: {
                type: 'VTextarea',
                name: `input-lain-${ins.k_koordinator_instrumen_psp}-${otherValue.value}`,
                label: 'Tuliskan jawaban lainnya',
                placeholder: 'Tuliskan jawaban lainnya',
                hint: 'wajib diisi',
                required: true,
                outlined: true,
                dense: true,
                singleLine: true,
                hideDetails: true,
                rows: 2,
                autoGrow: true,
                grid: { cols: 12, md: 6 },
              },
            });
          } else if (ins.tipe === 'radio') {
            const gridLg = [
              [102, 108],
              [110, 116],
              [118, 119],
            ];
            let gridLgRows = [];
            for (const ins of gridLg) {
              for (let i = ins[0]; i <= ins[1]; i++) {
                gridLgRows.push(i);
              }
            }

            let rows = [...[5, 62, 64, 65, 67, 68, 70], ...gridLgRows];

            result[keyInstrumen].push({
              id: (ins.k_koordinator_instrumen_psp || '').toString(),
              type: 'VRadio',
              name: `instrumen-radio-${ins.k_koordinator_instrumen_psp}`,
              label: ins.keterangan,
              labelColor: 'indigo',
              bgColor: 'grey lighten-3 pa-2 mb-4',
              hint: 'wajib diisi',
              items,
              customClass: 'mt-0',
              hideDetails: true,
              outlined: true,
              dense: true,
              row: rows.includes(+ins.k_koordinator_instrumen_psp),
              singleLine: false,
              grid: { cols: 12, md: 12 },
              gridLg: gridLgRows.includes(+ins.k_koordinator_instrumen_psp) ? '3' : '',
              useOthers: true,
              readonly: this.isPreview,
              othersValue: othersValue.map((val) => +val.value),
              others: {
                type: 'VTextarea',
                name: `input-lain-${ins.k_koordinator_instrumen_psp}-${otherValue.value}`,
                label: 'Tuliskan jawaban lainnya',
                placeholder: 'Tuliskan jawaban lainnya',
                hint: 'wajib diisi',
                required: true,
                outlined: true,
                dense: true,
                singleLine: true,
                hideDetails: true,
                rows: 2,
                autoGrow: true,
                grid: { cols: 12, md: 6 },
              },
            });
          } else if (ins.tipe === 'number') {
            result[keyInstrumen].push({
              id: (ins.k_koordinator_instrumen_psp || '').toString(),
              type: 'VTextField',
              name: `instrumen-input-${ins.k_koordinator_instrumen_psp}`,
              label: ins.keterangan,
              labelColor:
                this.isNotEmpty &&
                !this.form[`instrumen-input-${ins.k_koordinator_instrumen_psp}`] &&
                this.form[`instrumen-input-${ins.k_koordinator_instrumen_psp}`] !== 0
                  ? 'red'
                  : 'indigo',
              hint: '',
              mask: '#####',
              customClass: 'mt-0',
              placeholder: 'Tuliskan angka',
              outlined: true,
              singleLine: true,
              hideDetails: true,
              dense: true,
              readonly: this.readOnly,
              grid: { cols: 12, md: 6, sm: 12 },
            });
          } else if (ins.tipe === 'textarea') {
            result[keyInstrumen].push({
              id: (ins.k_koordinator_instrumen_psp || '').toString(),
              type: 'VTextarea',
              name: `instrumen-input-${ins.k_koordinator_instrumen_psp}`,
              label: ins.keterangan,
              labelColor: validator.min_words
                ? !!this.form[`instrumen-input-${ins.k_koordinator_instrumen_psp}`] &&
                  this.$wordCount(this.form[`instrumen-input-${ins.k_koordinator_instrumen_psp}`] || '') <
                    validator.min_words
                  ? 'red'
                  : 'indigo'
                : 'indigo',
              customClass: 'mt-0',
              placeholder: `Tuliskan jawaban ${
                validator.min_words
                  ? `(minimal ${validator.min_words} kata)`
                  : validator.max_words
                  ? `(maksimal ${counter} kata)`
                  : ''
              }`,
              hint: validator.min_words ? `Deskripsi minimal ${validator.min_words} kata` : '',
              required: false,
              outlined: true,
              singleLine: true,
              dense: true,
              readonly: this.isPreview,
              rows: 3,
              autoGrow: true,
              counter: counter,
              counterValue: (v) => this.$wordCount(v),
              grid: { cols: 12, md: 12, sm: 12 },
            });
          } else if (ins.tipe === 'date') {
            result[keyInstrumen].push({
              id: (ins.k_koordinator_instrumen_psp || '').toString(),
              type: 'VDatePicker',
              name: `instrumen-input-${ins.k_koordinator_instrumen_psp}`,
              label: ins.keterangan,
              labelColor: 'indigo',
              usePrependInnerIcon: 'mdi-calendar-month',
              hint: 'wajib diisi',
              outlined: true,
              singleLine: true,
              disabled: this.readOnly,
              hideDetails: true,
              dense: true,
              grid: { cols: 12, md: 12, sm: 12 },
            });
          }
        }
      }

      return result;
    },

    schema() {
      if (!this.type) return [];

      const types = {
        fasilitator: 'schemaFasilitator',
        sekolah: 'schemaSekolah',
        daerah: 'schemaDaerah',
      };

      const types2023 = {
        fasilitator: 'schemaFasilitator2023',
        sekolah: 'schemaSekolah2023',
        daerah: 'schemaDaerah2023',
        'progres-fsp': 'schemaPerkembangan2023',
      };

      const types2024 = {
        ds24: 'schemaPendampingan2024',
      };

      if (+this.info.pendampingan_tahun >= 2024) {
        return this[types2024[this.type]];
      }

      if (+this.info.pendampingan_tahun === 2023) {
        return this[types2023[this.type]];
      }

      return this[types[this.type]];
    },

    schemaBerkas() {
      if (!this.type) return [];

      const types = {
        fasilitator: 'schemaBerkasFasilitator',
        sekolah: 'schemaBerkasSekolah',
        daerah: 'schemaBerkasDaerah',
        ds24: 'schemaBerkas2024',
      };

      return this[types[this.type]];
    },

    schemaMeetings() {
      return [
        {
          disabled: this.isPreview,
          type: 'VTextField',
          name: 'url_meeting',
          label: `Rekaman Video Conference taruh URL, video rekaman disini ${
            this.type === 'daerah' && +this.info.pendampingan_tahun >= 2023 ? '(Opsional)' : ''
          }`,
          labelColor: 'indigo',
          hint: '',
          required: !(this.type === 'daerah' && +this.info.pendampingan_tahun >= 2023),
          grid: { cols: 12, md: 12, sm: 12 },
          outlined: true,
          singleLine: true,
          dense: true,
          readonly: this.readonly,
          prependInnerIcon: 'mdi-video',
          hideDetails: true,
        },
      ];
    },

    schemaFasilitator() {
      const bulan = this.$getDeepObj(this.info, 'bulan') || '';

      return {
        dasar: {
          title: 'Informasi Dasar Kegiatan',
          laporan: [
            {
              type: 'textView',
              label: 'Bulan Pelaksanaan',
              labelColor: 'grey',
              bgColor: 'grey lighten-3 pa-2 mb-4',
              value: bulan || '',
              grid: { cols: 12, md: 6 },
            },
            {
              type: 'VDatePicker',
              name: 'tgl_pelaksanaan',
              label: 'Tanggal Pelaksanaan',
              labelColor: 'grey',
              usePrependInnerIcon: 'mdi-calendar-month',
              hint: 'wajib diisi',
              required: true,
              outlined: true,
              singleLine: true,
              hideDetails: true,
              dense: true,
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              disabled: this.isPreview,
              type: 'VSelect',
              name: 'k_koordinator_moda_psp',
              label: 'Moda yang diterapkan',
              labelColor: 'grey',
              hint: 'wajib diisi',
              items: this.$mapForMaster(this.$getDeepObj(this.masters, 'koordinator_moda_psp') || {}),
              outlined: true,
              singleLine: true,
              readonly: this.readOnly,
              dense: true,
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              disabled: this.isPreview,
              type: 'VTextField',
              name: 'jml_peserta',
              label: 'Jumlah peserta (FSP) hadir',
              labelColor: 'grey',
              hint: '',
              mask: '###',
              required: false,
              outlined: true,
              singleLine: true,
              hideDetail: true,
              dense: true,
              readonly: this.readOnly,
              grid: { cols: 12, md: 3, sm: 12 },
            },
            {
              disabled: this.isPreview,
              type: 'VTextField',
              name: 'jml_peserta_absen',
              label: 'Jumlah peserta (FSP) tidak hadir',
              labelColor: 'grey',
              hint: '',
              mask: '###',
              required: false,
              outlined: true,
              singleLine: true,
              dense: true,
              readonly: this.readOnly,
              grid: { cols: 12, md: 3, sm: 12 },
            },
            {
              disabled: this.isPreview,
              exist: { status: +this.form.jml_peserta_absen > 0 },
              type: 'VTextarea',
              name: 'keterangan_absen',
              label: 'Keterangan peserta (FSP) yang tidak hadir',
              labelColor: 'grey',
              placeholder: 'Tuliskan keterangan peserta (FSP) yang tidak hadir',
              required: false,
              outlined: true,
              singleLine: true,
              dense: true,
              readonly: this.readOnly,
              rows: 4,
              autoGrow: true,
              grid: { cols: 12, md: 12, sm: 12 },
            },
          ],
        },
        isian: {
          title: 'Isian Laporan',
          laporan: [
            {
              disabled: this.isPreview,
              type: 'VTextarea',
              name: 'cakupan_diskusi',
              label: 'Cakupan diskusi',
              labelColor: 'grey',
              placeholder: 'Tuliskan cakupan diskusi (150 - 300 kata)',
              hint: `150 - 300 kata`,
              counter: 300,
              counterValue: (v) => this.$wordCount(v),
              required: false,
              outlined: true,
              singleLine: true,
              dense: true,
              readonly: this.readOnly,
              rows: 4,
              autoGrow: true,
              grid: { cols: 12, md: 12, sm: 12 },
            },
            {
              disabled: this.isPreview,
              type: 'VTextarea',
              name: 'deskripsi',
              label: 'Deskripsi',
              labelColor: 'grey',
              placeholder: 'Tuliskan deskripsi (150 - 300 kata)',
              hint: `150 - 300 kata`,
              counter: 300,
              counterValue: (v) => this.$wordCount(v),
              required: false,
              outlined: true,
              singleLine: true,
              dense: true,
              readonly: this.readOnly,
              rows: 4,
              autoGrow: true,
              grid: { cols: 12, md: 12, sm: 12 },
            },
            {
              disabled: this.isPreview,
              type: 'VTextarea',
              name: 'tindak_lanjut',
              label: 'Tindak Lanjut',
              labelColor: 'grey',
              placeholder: 'Tuliskan tindak lanjut (150 - 300 kata)',
              hint: `150 - 300 kata`,
              counter: 300,
              counterValue: (v) => this.$wordCount(v),
              required: false,
              outlined: true,
              singleLine: true,
              dense: true,
              readonly: this.readOnly,
              rows: 4,
              autoGrow: true,
              grid: { cols: 12, md: 12, sm: 12 },
            },
          ],
        },
      };
    },

    schemaSekolah() {
      return {
        dasar: {
          title: 'Informasi Dasar Kegiatan',
          laporan: [
            {
              type: 'VRadio',
              name: 'is_terlaksana',
              label: 'Apakah ada forum PMO level sekolah bulan ini?',
              labelColor: 'grey',
              hint: 'wajib diisi',
              required: true,
              items: [
                { text: 'Ya', value: 1 },
                { text: 'Tidak', value: 0 },
              ],
              grid: { cols: 12, md: 6 },
            },
            {
              exist: { status: +this.form.is_terlaksana === 0 },
              type: 'VTextarea',
              name: 'alasan_lain',
              label: 'Alasan lainnya tidak menyelenggarakan kegiatan',
              placeholder: 'Tuliskan alasan',
              labelColor: 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12, md: 6 },
              outlined: true,
              dense: true,
              singleLine: true,
              rows: 2,
              autoGrow: true,
            },
            {
              exist: { status: +this.form.is_terlaksana === 1 },
              disabled: this.isPreview,
              type: 'VDatePicker',
              name: 'tgl_pelaksanaan',
              label: 'Tanggal Pelaksanaan',
              labelColor: 'grey',
              usePrependInnerIcon: 'mdi-calendar-month',
              hint: 'wajib diisi',
              required: true,
              outlined: true,
              singleLine: true,
              hideDetails: true,
              dense: true,
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              exist: { status: +this.form.is_terlaksana === 1 },
              disabled: this.isPreview,
              type: 'VSelect',
              name: 'k_koordinator_moda_psp',
              label: 'Moda kegiatan forum',
              labelColor: 'grey',
              hint: 'wajib diisi',
              items: this.$mapForMaster(this.$getDeepObj(this.masters, 'koordinator_moda_psp') || {}),
              outlined: true,
              singleLine: true,
              readonly: this.readOnly,
              dense: true,
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              exist: { status: +this.form.is_terlaksana === 1 },
              disabled: this.isPreview,
              type: 'VTextField',
              name: 'jml_sekolah',
              label: 'Jumlah sekolah/kegiatan yang dihadiri',
              labelColor: 'grey',
              hint: '',
              mask: '###',
              required: false,
              outlined: true,
              singleLine: true,
              hideDetail: true,
              dense: true,
              readonly: this.readOnly,
              grid: { cols: 12, md: 3, sm: 12 },
            },
            {
              exist: { status: +this.form.is_terlaksana === 1 },
              disabled: this.isPreview,
              type: 'VTextField',
              name: 'jml_peserta',
              label: 'Jumlah peserta yang hadir',
              labelColor: 'grey',
              hint: '',
              mask: '###',
              required: false,
              outlined: true,
              singleLine: true,
              hideDetail: true,
              dense: true,
              readonly: this.readOnly,
              grid: { cols: 12, md: 3, sm: 12 },
            },
          ],
        },
        isian: {
          hidden: +this.form.is_terlaksana !== 1,
          title: 'Isian Laporan',
          laporan: [
            {
              disabled: this.isPreview,
              type: 'VTextarea',
              name: 'deskripsi',
              label: 'Rangkuman pelaksanaan',
              labelColor: 'grey',
              placeholder: 'Tuliskan rangkuman pelaksanaan (150 - 300 kata)',
              hint: `150 - 300 kata`,
              counter: 300,
              counterValue: (v) => this.$wordCount(v),
              required: false,
              outlined: true,
              singleLine: true,
              dense: true,
              readonly: this.readOnly,
              rows: 4,
              autoGrow: true,
              grid: { cols: 12, md: 12, sm: 12 },
            },
          ],
        },
      };
    },

    schemaDaerah() {
      const bulan = this.$getDeepObj(this.info, 'bulan') || '';

      return {
        dasar: {
          title: 'Informasi Dasar Kegiatan',
          laporan: [
            {
              type: 'textView',
              label: 'Bulan Pelaksanaan',
              labelColor: 'grey',
              bgColor: 'grey lighten-3 pa-2 mb-4',
              value: bulan || '',
              grid: { cols: 12, md: 6 },
            },
            {
              type: 'VRadio',
              name: 'is_terlaksana',
              label: 'Apakah ada forum PMO level daerah bulan ini?',
              labelColor: 'grey',
              hint: 'wajib diisi',
              required: true,
              items: [
                { text: 'Ya', value: 1 },
                { text: 'Tidak', value: 0 },
              ],
              grid: { cols: 12, md: 6 },
            },
            {
              disabled: this.isPreview,
              exist: { status: +this.form.is_terlaksana === 1 },
              type: 'VDatePicker',
              name: 'tgl_pelaksanaan',
              label: 'Tanggal Pelaksanaan',
              labelColor: 'grey',
              usePrependInnerIcon: 'mdi-calendar-month',
              hint: 'wajib diisi',
              required: true,
              outlined: true,
              singleLine: true,
              hideDetails: true,
              dense: true,
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              disabled: this.isPreview,
              exist: { status: +this.form.is_terlaksana === 1 },
              type: 'VSelect',
              name: 'k_koordinator_moda_psp',
              label: 'Moda yang diterapkan',
              labelColor: 'grey',
              hint: 'wajib diisi',
              items: this.$mapForMaster(this.$getDeepObj(this.masters, 'koordinator_moda_psp') || {}),
              outlined: true,
              singleLine: true,
              readonly: this.readOnly,
              dense: true,
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              show: { status: +this.form.is_terlaksana === 1 },
              type: 'cascade',
              labelColor: 'grey',
              configs: this.configs,
              grid: { cols: 12 },
            },
            {
              disabled: this.isPreview,
              show: { status: +this.form.is_terlaksana === 0 },
              type: 'VSelect',
              name: 'k_koordinator_alasan_psp',
              label: 'Alasan tidak adanya kegiatan',
              labelColor: 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12, md: 6 },
              items: this.$mapForMaster(this.masters.koordinator_alasan_psp || {}),
              itemText: 'text',
              itemValue: 'value',
              outlined: true,
              dense: true,
              singleLine: true,
            },
            {
              show: { status: +this.form.is_terlaksana === 0 && +this.form.k_koordinator_alasan_psp === 9 },
              type: 'VTextarea',
              name: 'alasan_lain',
              label: 'Alasan lainnya tidak menyelenggarakan kegiatan',
              labelColor: 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12, md: 6 },
              outlined: true,
              dense: true,
              singleLine: true,
              rows: 2,
              autoGrow: true,
            },
          ],
        },
      };
    },

    schemaBerkasFasilitator() {
      return [
        {
          label: 'presensi-peserta',
          title: 'Daftar hadir Peserta',
          max: 1,
          berkases: this.berkases.filter((berkas) => +berkas.k_koordinator_laporan_berkas_psp === 1) || [],
        },
        {
          label: 'bukti-fisik',
          title: 'Bukti fisik dokumen yang relevan (jika ada)',
          max: 1,
          berkases: this.berkases.filter((berkas) => +berkas.k_koordinator_laporan_berkas_psp === 2) || [],
        },
        {
          hidden: !this.isInputFoto,
          label: 'dokumentasi',
          title: 'Foto Kegiatan',
          desc: 'Sematkan minimal 1 dan maksimal 4 foto kegiatan.',
          max: 4,
          berkases: this.berkases.filter((berkas) => +berkas.k_koordinator_laporan_berkas_psp === 6) || [],
        },
      ];
    },

    schemaBerkasSekolah() {
      return [
        {
          hidden: +this.form.is_terlaksana !== 1,
          label: 'bukti-kfsp',
          title: 'Bukti Kehadiran KFSP',
          max: 1,
          berkases: this.berkases.filter((berkas) => +berkas.k_koordinator_laporan_berkas_psp === 11) || [],
        },
        {
          hidden: +this.form.is_terlaksana !== 1,
          label: 'bukti-fisik',
          title: 'Bukti fisik dokumen yang relevan (jika ada)',
          max: 1,
          berkases: this.berkases.filter((berkas) => +berkas.k_koordinator_laporan_berkas_psp === 2) || [],
        },
        {
          hidden: +this.form.is_terlaksana !== 1 || !this.isInputFoto,
          label: 'dokumentasi',
          title: 'Foto Kegiatan',
          desc: 'Sematkan minimal 1 dan maksimal 4 foto kegiatan.',
          max: 4,
          berkases: this.berkases.filter((berkas) => +berkas.k_koordinator_laporan_berkas_psp === 6) || [],
        },
      ];
    },

    schemaBerkasDaerah() {
      if (+this.info.pendampingan_tahun >= 2023) {
        return [
          {
            hidden: +this.form.is_terlaksana !== 1,
            label: 'bukti-kfsp',
            title: 'Bukti kehadiran KFSP dalam PMO level daerah',
            desc: 'Sematkan minimal 1 dan maksimal 4 berkas.',
            max: 4,
            berkases: this.berkases.filter((berkas) => +berkas.k_koordinator_laporan_berkas_psp === 11) || [],
          },
          {
            hidden: +this.form.is_terlaksana !== 1,
            label: 'bukti-pmo',
            title: 'Lampiran paparan PMO level daerah (sesuai format)',
            max: 1,
            berkases: this.berkases.filter((berkas) => +berkas.k_koordinator_laporan_berkas_psp === 21) || [],
          },
          {
            hidden: +this.form.is_terlaksana !== 1,
            label: 'paparan',
            title: 'Daftar hadir PMO level daerah',
            max: 1,
            berkases: this.berkases.filter((berkas) => +berkas.k_koordinator_laporan_berkas_psp === 22) || [],
          },
          {
            hidden: +this.form.is_terlaksana !== 1,
            label: 'dokumentasi',
            title: 'Dokumen lain yang mendukung (jika ada)',
            max: 1,
            berkases: this.berkases.filter((berkas) => +berkas.k_koordinator_laporan_berkas_psp === 6) || [],
          },
        ];
      }

      return [
        {
          hidden: +this.form.is_terlaksana !== 1,
          label: 'bukti-pmo',
          title: 'Bukti kehadiran KFSP dalam PMO level daerah',
          max: 1,
          berkases: this.berkases.filter((berkas) => +berkas.k_koordinator_laporan_berkas_psp === 21) || [],
        },
        {
          hidden: +this.form.is_terlaksana !== 1,
          label: 'paparan',
          title: 'Lampiran paparan PMO level daerah (sesuai format)',
          max: 1,
          berkases: this.berkases.filter((berkas) => +berkas.k_koordinator_laporan_berkas_psp === 22) || [],
        },
        {
          hidden: +this.form.is_terlaksana !== 1,
          label: 'dokumentasi',
          title: 'Dokumen lain yang mendukung (jika ada)',
          max: 1,
          berkases: this.berkases.filter((berkas) => +berkas.k_koordinator_laporan_berkas_psp === 2) || [],
        },
      ];
    },

    schemaBerkas2024() {
      return [
        {
          type: 'gdrive',
          label: 'url-presensi',
          title: 'Dokumen Daftar Kehadiran',
          max: 1,
          berkases: this.berkases.filter((berkas) => +berkas.k_koordinator_laporan_berkas_psp === 31) || [],
        },
        {
          type: 'gdrive',
          label: 'url-dokumentasi',
          title: 'Dokumentasi Kegiatan',
          max: 1,
          berkases: this.berkases.filter((berkas) => +berkas.k_koordinator_laporan_berkas_psp === 32) || [],
        },
      ];
    },
  },
};
